import React, { useMemo, useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import DashboardLayout from "@/layouts/DashboardLayout";
import Header from "@/components/ui/header";
import Input from "@/components/ui/input";
import { Search as SearchIcon } from "@/components/icons";
import ReportCategorySection from "../components/ReportCategorySection";
import {
  REPORT_CATEGORIES,
  REPORT_CATALOG,
  getReportsByCategory,
} from "../constants/report-catalog";
import styles from "./ReportsHomePage.module.scss";

const ReportsHomePage: React.FC = () => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    const q = search.trim().toLocaleLowerCase("tr");
    if (!q) return null;
    return REPORT_CATALOG.filter(
      (r) =>
        r.title.toLocaleLowerCase("tr").includes(q) ||
        r.description.toLocaleLowerCase("tr").includes(q),
    );
  }, [search]);

  const totalReports = REPORT_CATALOG.length;

  return (
    <DashboardLayout>
      <Header title={t("reportsHome.headerTitle")} />
      <div className={styles.hero}>
        <div className={styles.heroText}>
          <h2 className={styles.heroTitle}>{t("reportsHome.heroTitle")}</h2>
          <p className={styles.heroSubtitle}>
            <Trans
              i18nKey="reportsHome.heroSubtitle"
              values={{
                totalReports,
                categoryCount: REPORT_CATEGORIES.length,
              }}
              components={{ strong: <strong /> }}
            />
          </p>
        </div>
        <div className={styles.search}>
          <Input
            placeholder={t("reportsHome.searchPlaceholder")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            startIcon={<SearchIcon width={18} height={18} />}
          />
        </div>
      </div>
      <div className={styles.content}>
        {filtered ? (
          filtered.length === 0 ? (
            <div className={styles.emptyState}>
              {t("reportsHome.noMatch")}
            </div>
          ) : (
            <ReportCategorySection
              category={{
                key: "strategic",
                title: `Arama Sonuçları (${filtered.length})`,
                description: `"${search}" için bulunan raporlar`,
                order: 0,
              }}
              reports={filtered}
            />
          )
        ) : (
          REPORT_CATEGORIES.map((cat) => (
            <ReportCategorySection
              key={cat.key}
              category={cat}
              reports={getReportsByCategory(cat.key)}
            />
          ))
        )}
      </div>
    </DashboardLayout>
  );
};

export default ReportsHomePage;
